// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3Yuos","footer":"styles_footer__1WuF6","passCodeTooltip":"styles_passCodeTooltip__3o-Ek"};